import * as React from "react";
import Select from "react-select";
import PrimaForm from "../PrimaForm";

var AnnulmentForm = function AnnulmentForm(props) {
  var poliza = props.poliza,
      polizaEndorsement = props.polizaEndorsement,
      polizaEndorsementForm = props.polizaEndorsementForm,
      onChangeAmount = props.onChangeAmount,
      cancelReasons = props.cancelReasons;
  props;
  var defaultCancelReason = cancelReasons.find(function (reason) {
    return (polizaEndorsement === null || polizaEndorsement === void 0 ? void 0 : polizaEndorsement.cancel_reason) === reason.value;
  });

  var onChangeAnnulmentReason = function onChangeAnnulmentReason(item) {
    var _poliza$broker_inform, _poliza$broker_inform2;

    return onChangeAmount({
      cancel_reason: item.value,
      exempt_net_bonus: -((_poliza$broker_inform = poliza.broker_information) === null || _poliza$broker_inform === void 0 ? void 0 : _poliza$broker_inform.exempt_net_bonus),
      affects_net_bonus: -((_poliza$broker_inform2 = poliza.broker_information) === null || _poliza$broker_inform2 === void 0 ? void 0 : _poliza$broker_inform2.affects_net_bonus)
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Raz\xF3n de anulaci\xF3n"), /*#__PURE__*/React.createElement(Select, {
    options: cancelReasons,
    defaultValue: defaultCancelReason,
    isSearchable: true,
    placeholder: "Selecciona raz\xF3n de anulaci\xF3n...",
    onChange: onChangeAnnulmentReason
  }))), /*#__PURE__*/React.createElement(PrimaForm, {
    canModify: true,
    poliza: poliza,
    polizaEndorsementForm: polizaEndorsementForm,
    onChangeAmount: onChangeAmount
  }));
};

export default AnnulmentForm;